import { useQuery } from "react-query";
import Select from "react-select";

import { getDepartments } from "../../../../../MyApi/sb/departments";
import { getBranches } from "../../../../../MyApi/sb/branches";
import { getNationalities } from "../../../../../MyApi/sb/natonalities";

import { useTranslation } from "react-i18next";

const SubFilterEmployes = ({
  branchId,
  setName,
  setSbBranchId,
  setSbDepartmentId,
  setSbNationalityId,
  setActive,
}) => {
  const { t } = useTranslation();
  const page = 0;
  const DepartmentsQuery = useQuery(["getDepartments", page, branchId], () =>
    getDepartments(page, branchId)
  );

  const branchQuery = useQuery(["getbranches", page], () => getBranches(page));
  const nationalityQuery = useQuery("getnationality", getNationalities);

  const branches = branchQuery.data?.data || [];
  const departments = DepartmentsQuery.data?.data || [];
  const nationalities = nationalityQuery.data?.data || [];

  const handelNameChange =(e)=>{
    const {value}=e.target
     setName(value)
  }

  const handelBranchChange = (selectedBranch) => {
    const branchId = selectedBranch ? selectedBranch.id : 0;
    setSbBranchId(branchId);
  };
  const handleDepartmentsChange = (selectedDepartment) => {
    const departmentId = selectedDepartment ? selectedDepartment.id : 0;
    setSbDepartmentId(departmentId);
  };
  const handleNationalityChange = (selectedNationality) => {
    const nationalityId = selectedNationality ? selectedNationality.id : 0;
    setSbNationalityId(nationalityId);
  };
  const handelActiveChange =(e)=>{
    const {value} =e.target
    setActive(value)
  }
  return (
    <div className="card">
        <div className="card-body">
        <div className="row">
        <div className="col-6 col-md">
            <label htmlFor="">{t("Name")}</label>
            <input type="text" className="form-control" onChange={handelNameChange} />
        </div>
        <div className="col-6 col-md">
          <label htmlFor="">{t("Nationalities")}</label>
          <Select
            type="text"
            name="employes"
            isClearable={true}
            onChange={handleNationalityChange}
            options={nationalities}
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            placeholder="search"
          />
        </div>
        <div className="col-6 col-md">
          <label htmlFor="">{t("Branches")}</label>
          <Select
            type="text"
            name="branches"
            isClearable={true}
            onChange={handelBranchChange}
            options={branches}
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            placeholder="search"
          />
        </div>
        
        <div className="col-6 col-md">
          <label htmlFor="">{t("Departments")}</label>
          <Select
            type="text"
            name="departments"
            isClearable={true}
            onChange={handleDepartmentsChange}
            options={departments}
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            placeholder="search"
          />
        </div>


        <div className="col-6 col-md">
          <label htmlFor="">{t("Status")}</label>
        <select className="form-select" onChange={handelActiveChange}>
            <option value="">الكل</option>
            <option value="1">نشط</option>
            <option value="0">غير نشط</option>
        </select>
        </div>
      </div>
        </div>
   
    </div>
  );
};

export default SubFilterEmployes;
